// Input.jsxs
import React from 'react'
import { CFieldProps } from '@velocity/shared'
import { useField } from 'formik'

const Textarea = (props: CFieldProps) => {
  const [field, meta] = useField(props.name)

  return (
    <textarea
      {...props}
      {...props.fieldProps}
      {...field}
      className={`p-2 border-gray-200 rounded-md w-full border ${props.disabled ? 'bg-[#EEEEEE]' : ''} ${
        meta?.touched && meta?.error ? 'border-red-500' : 'border-gray-300'
      } rounded-md`}
    ></textarea>
  )
}

export default Textarea
